import React from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'
import moment from 'moment'
export default function WDateTimeField({data, onChange, tabActive}) {
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <TextField
          id="outlined-adornment-amount"
          variant="outlined"
          value={moment().format('YYYY-MM-DDTHH:mm')}
          label={data.name}
          type={'datetime-local'}
          labelWidth={60}
          InputLabelProps={{
            shrink: true,
          }}
          disabled
        />
        <FormHelperText>
          {(() => {
            if (
              (tabActive === 'upcoming' && data.is_required) ||
              (tabActive === 'ongoing' && data.is_required_return)
            ) {
              return 'required*'
            } else {
              return 'optional'
            }
          })()}
        </FormHelperText>
      </FormControl>
    </Grid>
  )
}
